import { MenuItem } from '../menu';

export const portfolioMenuItem: MenuItem = {
  id: 'portfolio',
  link: '',
  displayName: 'portfolio',
  customClasses: [],
  items: [
    {
      id: 'menu-item--codes',
      link: '/codes',
      displayName: 'Codes',
      customClasses: ['hover-backend'],
      items: [
        {
          id: 'github-repo',
          link: 'https://github.com/nightingalemedia',
          displayName: 'My Github Repo',
          customClasses: [],
          items: [],
        },
        {
          id: 'project-1',
          link: '/projects/ncaa-marketplace-startup/',
          displayName: 'Full Stack Marketplace Startup',
          customClasses: [],
          items: [],
          info: 'My most recent role as a full-stack developer saw me faced with a time-sensitive project to build, manage and customize an application for a consistent influx of clients seeking virtual event experiences.  ** The product is a full-stack application using Strapi as a CMS and Next.js/React as a front-end interactive modular website.  If you want to request a full-demo please contact me.',
        },
        {
          id: 'project-2',
          link: '/projects/planes-logistics-erp/',
          displayName: 'Enterprise ERP',
          customClasses: [],
          items: [],
          info: 'One of my favorite skills that coding gives me is my ability to help experience-designers to create digitally-savvy installations and experiences.  I use RaspberryPi and Arduinos to help create flashy, interactive and involved experiences. ** I am working to get a gallery of these together, please check back soon!',
        },
        {
          id: 'explore-this-site',
          link: 'https://github.com/NightingaleMedia/personal-website__frontend',
          displayName: "Explore This Site's Repo",
          customClasses: [],
          items: [],
          info: 'Learning React and the many possibilities it offers has been my favorite past-time over the last year. ** I built this site to allow users to scratch the surface of what I have learned.  I hope you enjoy it as much as I do.',
        },
        {
          id: 'all',
          link: '/codes',
          displayName: 'All Projects',
          customClasses: [],
          items: [],
        },
      ],
    },
    {
      id: 'menu-item--sounds',
      link: '',
      displayName: 'Sounds',
      customClasses: ['hover-creative'],
      items: [
        {
          id: 'commercial-audio',
          link: 'https://youtube.com/playlist?list=PLGVZlmzZDMxIRHtbJ4rzRg0b2aLWrl9fV',
          displayName: 'Commercial Audio',
          customClasses: [],
          items: [],
          info: 'I have worked with some of the most recognizable companies helping create memorable and fitting music and sound design behind their ads.  ** Click the link to take you to me highlight reel.',
        },
        {
          id: 'music-production',
          link: '',
          displayName: 'Music Production',
          customClasses: [],
          items: [],
          info: 'Before I was a developer I made my living as a full-time music producer, touring artist, and musician.  I am working on getting a gallery of these projects together. ** Check back soon!',
        },
        {
          id: 'my-personal-music',
          link: 'https://open.spotify.com/artist/0PfHJAlpEVJcWdM5ZUzChk',
          displayName: 'My Personal Music',
          customClasses: [],
          items: [],
        },
      ],
    },
    {
      id: 'menu-item--words',
      link: '',
      displayName: 'Words',
      customClasses: ['hover-other'],
      items: [
        {
          id: 'blog',
          link: 'https://medium.com/@alsigman',
          displayName: 'My Blog',
          customClasses: [],
          items: [],
          info: 'Coming Soon!',
        },
        {
          id: 'value-statement',
          link: '',
          displayName: 'Value Statement',
          customClasses: [],
          items: [],
          info: `In my career I have kept three things to heart.  Be creative, stay curious and always challenge yourself.  In my life so far I have had some amazing opportunities to apply creativity to an ever-changing landscape of projects. 
            ** My journey so far has seen my music on national TV, over 400 shows touring across the country and living and working in some of the most exciting cities around the world.  All the while, I haven’t lost sight of the big picture and what I am passionate about: using my skills to better understand society and hopefully help make it a better place. 
            ** I came to technology in a roundabout way but a way but everyday it seems more like it made sense all along.  Every job I’ve had, I have been magnetically drawn to the technology behind the scenes. 
            ** The age of the internet has brought with it more modern more complex problems.  Complex problems require informed and thoughtful solutions. I look forward to using my ever-growing horizon of skills to help others interact with their environment and understand each other in new and compelling ways.
            `,
        },
      ],
    },
  ],
};
